import { Component } from '@angular/core';

@Component({
  selector: 'svg-file-generator',
  standalone: true,
  template: `
    <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="m26 16h-4a2.002 2.002 0 0 0 -2 2v12h2v-5h4v5h2v-12a2.002 2.002 0 0 0 -2-2zm-4 7v-5h4v5z" />
      <path d="m16 27a10.9862 10.9862 0 0 1 -9.2156-5h5.2156v-2h-8v8h2v-3.6851a13.0239 13.0239 0 0 0 10 4.6851z" />
      <path d="m20 10h5.2155a10.9973 10.9973 0 0 0 -20.2155 6h-2a13.0048 13.0048 0 0 1 23-8.3151v-3.6849h2v8h-8z" />
      <path d="m0 0h32v32h-32z" fill="none" />
    </svg>
  `,
  styleUrl: './svg.style.scss',
})
export class SvgFileGeneratorComponent {}
